function readCurrentClubId(): number | null {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const selectedClubId = Number(localStorage.getItem("Club_id"));

    if (user?.role?.name === "SUPER_ADMIN" && Number.isInteger(selectedClubId)) {
      return selectedClubId;
    }

    const clubId = Number(user?.club_id ?? user?.club?.id);
    return Number.isInteger(clubId) ? clubId : null;
  } catch {
    return null;
  }
}

export function isCustomerMessagesEnabledForCurrentClub(): boolean {
  // Customer Messages is enabled for all clubs.
  return readCurrentClubId() != null;
}
